import { useQuery } from 'react-query';
import { useResourcesApi } from 'services/api';
import { MACROS_IDS, MACROS_NAMES, VERSION_MACROS } from '../macrosConstants';

const handleMacrosResponse = macros => {
    if (!macros) {
        return {};
    }

    const liteUnitVersion = getMacroValue(macros, MACROS_IDS.LITE_UNIT_VERSION);
    const unitVersionDirect = getMacroValue(macros, MACROS_IDS.UNIT_VERSION_DIRECT);
    const playerVersion = getMacroValue(macros, MACROS_IDS.PLAYER_VERSION);

    return {
        [MACROS_NAMES.LITE_UNIT_VERSION]: liteUnitVersion,
        [MACROS_NAMES.PREVIEW_CONF_DESKTOP]: replaceVersionsInMacro(
            getMacroValue(macros, MACROS_IDS.PREVIEW_CONF_DESKTOP),
            liteUnitVersion,
            unitVersionDirect,
            playerVersion
        ),
        [MACROS_NAMES.PREVIEW_CONF_MOBILE]: replaceVersionsInMacro(
            getMacroValue(macros, MACROS_IDS.PREVIEW_CONF_MOBILE),
            liteUnitVersion,
            unitVersionDirect,
            playerVersion
        ),
    };
};

const getMacroValue = (macros, id) => {
    const macro = macros.find(macro => macro.id === id);

    return macro?.value || '';
};

const replaceVersionsInMacro = (macro, liteUnitVersion, unitVersionDirect, playerVersion) => {
    return macro
        .replace(VERSION_MACROS.LITE_UNIT_VERSION, liteUnitVersion)
        .replace(VERSION_MACROS.UNIT_VERSION_DIRECT, unitVersionDirect)
        .replace(VERSION_MACROS.PLAYER_VERSION, playerVersion);
};

export const useVideoMacros = () => {
    const ids = Object.values(MACROS_IDS).join(',');
    const { getVideoMacros } = useResourcesApi();

    const { data: macros, isLoading } = useQuery(['video-macros'], () => getVideoMacros(ids), {
        refetchOnWindowFocus: false,
        select: data => handleMacrosResponse(data?.results),
    });

    return { macros, isLoading };
};
